import { REPORTS_FREQUENCY_SLAB_TAB } from "../../framework/tab/tabUtilsConstants";
import moment from "moment";

export const columnDefs = [
  {
    headerName: "Frequency Slab Id",
    field: "frequencyId",
    locked: true,
    hide: false,
    width: 100,
  },
  {
    headerName: "Frequency Slab Name",
    field: "programName",
    locked: true,
    hide: false,
    width: 200,
  },
  {
    headerName: "Company",
    field: "company",
    locked: false,
    hide: false,
    width: 150,
  },
  {
    headerName: "Branches",
    field: "branchCode",
    locked: false,
    hide: false,
    width: 350,
  },
  {
    headerName: "Status",
    field: "deleted",
    locked: false,
    hide: false,
    width: 120,
  },
  {
    headerName: "Remarks",
    field: "remarks",
    locked: false,
    hide: false,
    width: 250,
  },
  {
    headerName: "Created Date",
    field: "createdTime",
    locked: false,
    hide: false,
    width: 180,
  },
  {
    headerName: "Created By",
    field: "createdBy",
    locked: false,
    hide: false,
    width: 150,
  },
  {
    headerName: "Updated Date",
    field: "updatedTime",
    locked: false,
    hide: false,
    width: 180,
  },
  {
    headerName: "Updated By",
    field: "updatedBy",
    locked: false,
    hide: false,
    width: 150,
  },
];
export const columnDefsFunctions = {
  frequencyId: {
    cellClass: (params) =>
      params.node.rowPinned ? "pinned-bottom-row" : "custom-ag-cell-link",
  },
  createdTime: {
    valueFormatter: (params) => {
      return moment(`${params.value}`).format("DD/MM/YYYY hh:mm A");
    },
  },
  updatedTime: {
    valueFormatter: (params) => {
      return moment(`${params.value}`).format("DD/MM/YYYY hh:mm A");
    },
  },
  deleted: {
    valueFormatter: (params) => {
      return params.value === true ? "INACTIVE" : "ACTIVE";
    },
    cellStyle: (params) => {
      return {
        borderRight: "1px solid #a0a0a0",
        ...(params.value === true && { color: "red" }),
        ...(params.value === false && { color: "green" }),
      };
    },
  },
};

export const initial_state_frequency_slab_report = {
  type: REPORTS_FREQUENCY_SLAB_TAB,
  label: "Frequency Slab Report",
  allowMultipleTabs: false,
};
